import type React from 'react';
import { forwardRef, type HTMLAttributes } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import type { IconMap } from 'autogen/iconMap';
import { useJavascriptRequestDataModelQuery } from 'autogen/swagger/all/hooks';
import icons from './icons';

export type IconProps = HTMLAttributes<HTMLOrSVGElement> &
    React.SVGAttributes<SVGElement> & { type: keyof IconMap; size: 16 | 24 };

const Icon = forwardRef<SVGElement, IconProps>((props, ref) => {
    const { type, size, ...restProps } = props;
    const { data } = useJavascriptRequestDataModelQuery({ enabled: false });
    const tenant = data?.segmentation.tenant.toLowerCase() || 'matas';

    // const IconComponent = useMemo(() => getIcon({ tenant, type, size }), [type, size, tenant]);
    const iconElement = icons[`../../../images/icons/design-system/${tenant}/${size}px/${type}.svg`]?.default({
        ...restProps,
        ref
    });

    if (!iconElement) {
        return null;
    }

    return iconElement;
});

export default withErrorBoundary(Icon, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
